import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=7a9ef4e8"
import script from "./Versions.vue?vue&type=script&lang=js"
export * from "./Versions.vue?vue&type=script&lang=js"
import style0 from "./Versions.vue?vue&type=style&index=0&id=7a9ef4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports